import * as _ from "lodash"
import {IHierarchyStructure, IHierarchyStructureLevel} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {WB_CustomerHierarchyLevelRow, WB_HierarchyLevelRow} from "../PA.Core/PAdbSchemaRows";
import {esWB_Customer_Hierarchy_Level, esWB_Product_Hierarchy_Level} from "../PA.Core/PAdbSchema";
import {GenericLevel} from "./GenericLevel";

export class CustomerLevel
    implements IHierarchyStructureLevel
{
    private _hierStructure: IHierarchyStructure
    private _levelId: string
    private _levelName: string
    private _levelDepth: number

    // typing properties
    private _levelUnique: boolean
    private _wbEntityId: number
    private _wbAttributeMId: number
    private _wbEntityId_Ent: number

    private _bDelete: boolean
    private _original: IHierarchyStructureLevel

    // Create on Save
    private custhLevelRow: WB_CustomerHierarchyLevelRow
    private hierLevelRow: WB_HierarchyLevelRow

    constructor(structure: IHierarchyStructure,
                options?: { lvlRow?: WB_CustomerHierarchyLevelRow,
                            hierLvlRow?: WB_HierarchyLevelRow })
    {
        this._hierStructure = structure
        this._bDelete = false
        this.custhLevelRow = options?.lvlRow
        this.hierLevelRow = options?.hierLvlRow
        this._levelUnique = false
        this._wbEntityId = 0
        this._wbAttributeMId = 0
        this._wbEntityId_Ent = 0

        if (!_.isEmpty(this.custhLevelRow)) {
            this._levelId = this.custhLevelRow.cif.LEVEL_ID
            this._levelName = this.custhLevelRow.cif.LEVEL_NAME
            this._levelDepth = this.custhLevelRow.cif.LEVEL_DEPTH
        }

        if(!_.isEmpty(this.hierLevelRow)){
            this._levelUnique = (this.hierLevelRow.cif.UNIQUE_IND == '1')
            this._wbEntityId = this.hierLevelRow.cif.WB_ENTITY_ID
            this._wbAttributeMId = this.hierLevelRow.cif.WB_ATTRIBUTEM_ID
            this._wbEntityId_Ent = this.hierLevelRow.cif.WB_ENTITY_ID_ENTERPRISE
        }

        this._original = new GenericLevel(structure, {clone: this})

    }

    get hierarchy(): IHierarchyStructure {
        return this._hierStructure
    }

    get levelId(): string {
        return this._levelId
    }

    get levelName(): string {
        return this._levelName
    }

    get levelDepth(): number {
        return this._levelDepth
    }

    setLevelId(id: string): void {
        this._levelId = id
    }

    setLevelName(name: string): void {
        this._levelName = name
    }

    setLevelDepth(depth: number): void {
        this._levelDepth = depth
    }


    //-- Typing Properties

    get levelUnique(): boolean {
        return this._levelUnique
    }

    get levelEntityTypeId(): number {
        return this._wbEntityId
    }

    get levelEntityAttributeId(): number {
        return this._wbAttributeMId
    }

    get levelEnterpriseEntityTypeId(): number {
        return this._wbEntityId_Ent
    }

    setLevelUnique(levelUnique: boolean): void {
        this._levelUnique = !!levelUnique
    }

    setLevelEntityType(wbEntityId: number): void {
        this._wbEntityId = wbEntityId || 0
    }

    setLevelEntityAttribute(wbAttributeMId: number): void {
        this._wbAttributeMId = wbAttributeMId || 0
    }

    setLevelEnterpriseEntityType(wbEntityId: number): void {
        this._wbEntityId_Ent = wbEntityId || 0
    }



    //-- Storage Properties
    get isActive(): boolean {
        return !this._bDelete
    }

    get isActiveNew(): boolean {
        return (_.isEmpty(this.custhLevelRow) && !this._bDelete)
    }

    get isModified(): boolean {
        if (_.isEmpty(this.custhLevelRow))
            return false

        if (this._bDelete && !_.isEmpty(this.custhLevelRow))
            return true


        if (this.custhLevelRow.cif.LEVEL_ID != this._levelId)
            return true

        if (this.custhLevelRow.cif.LEVEL_NAME != this._levelName)
            return true

        if (this.custhLevelRow.cif.LEVEL_DEPTH != this._levelDepth)
            return true

        return false
    }

    get original(): IHierarchyStructureLevel {
        return this._original
    }

    Delete(): void {
        this._bDelete = true
    }

    async SaveBatch(): Promise<void> {
        const self = this

        // create record if needed
        if (_.isEmpty(self.custhLevelRow)) {
            if (self._bDelete)
                return
            self.custhLevelRow = <WB_CustomerHierarchyLevelRow>await self._hierStructure.dbContext.createRecordWithKey(esWB_Customer_Hierarchy_Level)
            self.custhLevelRow.setDefaults()
            self.custhLevelRow.cif.WB_CUSTH_ID = self._hierStructure.wbId
            self._hierStructure.dbContext.add(esWB_Customer_Hierarchy_Level, self.custhLevelRow)
        }

        if (self._bDelete) {
            self.custhLevelRow.markDeleted()

        } else {
            // Currently assumes everything is set..
            // Set child, parent, dates
            self.custhLevelRow.cif.LEVEL_ID = self._levelId || ('level' + self._levelDepth.toString())
            self.custhLevelRow.cif.LEVEL_NAME = self._levelName || ('Level ' + self._levelDepth.toString())
            self.custhLevelRow.cif.LEVEL_DEPTH = self._levelDepth
        }

        self._hierStructure.dbContext.SaveBatch(esWB_Customer_Hierarchy_Level, self.custhLevelRow)

    }

}